export default "__VITE_ASSET__DwMno9jK__"